module.exports = __webpack_public_path__ + "media/next-final.d7c73eed.mp4";